// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Research Page Styles */

/* Modal overlay - ensure visibility */
.modal-overlay:has(.message-modal) {
  opacity: 1 !important;
  visibility: visible !important;
  display: flex !important;
  align-items: center;
  justify-content: center;
}

/* Research form specific styles */
.research-form {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

/* Form sections */
.form-section {
  background: rgba(255, 255, 255, 0.6);
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 16px;
  padding: 20px;
}

/* Form row layouts */
.form-group-two-thirds {
  flex: 2 1;
}

.form-group-third {
  flex: 1 1;
}

/* Textarea */
.form-textarea {
  width: 100%;
  padding: 12px 16px;
  border: 1.5px solid rgba(0, 0, 0, 0.12);
  border-radius: 12px;
  font-size: 15px;
  font-family: inherit;
  background: #ffffff;
  color: var(--text-primary);
  resize: vertical;
  min-height: 60px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  transition: all 0.2s ease;
}

.form-textarea:hover {
  border-color: rgba(0, 0, 0, 0.2);
}

.form-textarea:focus {
  outline: none;
  border-color: var(--accent-orange);
  box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.12);
}

.form-textarea:disabled {
  background: rgba(0, 0, 0, 0.04);
  cursor: not-allowed;
}

/* Questions section */
.questions-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* Question card */
.question-card {
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  padding: 16px;
  transition: all 0.2s ease;
}

.question-card:hover {
  border-color: rgba(0, 0, 0, 0.12);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.question-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.question-number {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, #FF6B4A, #E94B6C);
  color: white;
  font-size: 12px;
  font-weight: 600;
  border-radius: 50%;
}

/* Creative break badge — distinct from question numbers. */
.question-number-creative {
  background: linear-gradient(135deg, #8E3A9A, #E94B6C);
}

.question-type-toggle {
  display: flex;
  background: rgba(0, 0, 0, 0.04);
  border-radius: 8px;
  padding: 2px;
}

.type-btn {
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 500;
  font-family: inherit;
  color: var(--text-secondary);
  background: transparent;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.15s ease;
}

.type-btn:hover:not(:disabled) {
  color: var(--text-primary);
}

.type-btn.active {
  background: white;
  color: var(--text-primary);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.type-btn:disabled {
  cursor: not-allowed;
}

.remove-question-btn {
  margin-left: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  background: transparent;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  color: var(--text-tertiary);
  transition: all 0.15s ease;
}

.remove-question-btn:hover {
  background: rgba(231, 76, 60, 0.1);
  color: #e74c3c;
}

.remove-question-btn svg {
  width: 16px;
  height: 16px;
}

.question-input {
  width: 100%;
  padding: 12px 14px;
  font-size: 15px;
  font-family: inherit;
  color: var(--text-primary);
  background: rgba(0, 0, 0, 0.02);
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 10px;
  transition: all 0.15s ease;
}

.question-input:hover:not(:disabled) {
  border-color: rgba(0, 0, 0, 0.12);
}

.question-input:focus {
  outline: none;
  border-color: var(--accent-orange);
  background: white;
  box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.1);
}

.question-input:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

/* Answers */
.answers-list {
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.answer-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.answer-marker {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  color: var(--text-tertiary);
  flex-shrink: 0;
}

.answer-marker svg {
  width: 16px;
  height: 16px;
}

.answer-input {
  flex: 1 1;
  padding: 10px 12px;
  font-size: 14px;
  font-family: inherit;
  color: var(--text-primary);
  background: rgba(0, 0, 0, 0.02);
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 8px;
  transition: all 0.15s ease;
}

.answer-input:hover:not(:disabled) {
  border-color: rgba(0, 0, 0, 0.12);
}

.answer-input:focus {
  outline: none;
  border-color: var(--accent-orange);
  background: white;
}

.answer-input:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.remove-answer-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background: transparent;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  color: var(--text-tertiary);
  transition: all 0.15s ease;
  flex-shrink: 0;
}

.remove-answer-btn:hover {
  background: rgba(231, 76, 60, 0.1);
  color: #e74c3c;
}

.remove-answer-btn svg {
  width: 14px;
  height: 14px;
}

.add-answer-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-left: 30px;
  padding: 8px 12px;
  font-size: 13px;
  font-weight: 500;
  font-family: inherit;
  color: var(--text-secondary);
  background: transparent;
  border: 1px dashed rgba(0, 0, 0, 0.15);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.15s ease;
}

.add-answer-btn:hover {
  color: var(--accent-orange);
  border-color: var(--accent-orange);
  background: rgba(255, 107, 74, 0.04);
}

.add-answer-btn svg {
  width: 14px;
  height: 14px;
}

/* Creative test — image answer options */
.creative-options {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 12px;
  margin-top: 8px;
}
.creative-option {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.creative-thumb {
  position: relative;
  aspect-ratio: 1 / 1;
  border: 1px solid #e5e5ee;
  border-radius: 10px;
  overflow: hidden;
  background: #fafafc;
  display: flex;
  align-items: center;
  justify-content: center;
}
.creative-thumb img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.creative-thumb-empty {
  border-style: dashed;
  color: #9b9ba8;
  font-size: 12px;
}
.creative-option-actions {
  display: flex;
  align-items: center;
  gap: 6px;
  justify-content: space-between;
}
.creative-upload-btn {
  flex: 1 1;
  text-align: center;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  color: #8E3A9A;
  background: #f6eef8;
  border-radius: 7px;
  padding: 6px 8px;
}
.creative-upload-btn:hover { background: #efe2f3; }
.creative-add {
  aspect-ratio: 1 / 1;
  flex-direction: column;
  border: 1px dashed #cfcfe0 !important;
}

/* Add question button */
.add-question-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  margin-bottom: 24px;
  padding: 14px;
  margin-top: 8px;
  font-size: 14px;
  font-weight: 500;
  font-family: inherit;
  color: var(--text-secondary);
  background: transparent;
  border: 2px dashed rgba(0, 0, 0, 0.12);
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.add-question-btn:hover {
  color: var(--accent-orange);
  border-color: var(--accent-orange);
  background: rgba(255, 107, 74, 0.04);
}

.add-question-btn svg {
  width: 18px;
  height: 18px;
}

/* Status badges */
.status-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.03em;
  border-radius: 12px;
  white-space: nowrap;
}

.status-draft {
  background: rgba(0, 0, 0, 0.06);
  color: var(--text-secondary);
}

.status-active {
  background: rgba(16, 185, 129, 0.1);
  color: #059669;
}

.status-completed {
  background: rgba(59, 130, 246, 0.1);
  color: #2563eb;
}

.status-paused {
  background: rgba(245, 158, 11, 0.1);
  color: #d97706;
}

/* Editor header with status */
.editor-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
}

.editor-header h2 {
  margin: 0;
}

/* Research list items - compact layout */
.url-lists-panel .list-item {
  gap: 10px;
  padding: 12px 12px;
}

.url-lists-panel .list-item-icon {
  width: 32px;
  height: 32px;
}

.url-lists-panel .list-item-icon svg {
  width: 16px;
  height: 16px;
}

/* Smaller status badge */
.url-lists-panel .status-badge {
  padding: 3px 8px;
  font-size: 10px;
  flex-shrink: 0;
}

/* DM Sans font for list items */
.url-lists-panel .list-item-name,
.url-lists-panel .list-item-meta {
  font-family: 'DM Sans', sans-serif;
}

/* Hide arrow to save space */
.url-lists-panel .list-item-arrow {
  display: none;
}

/* Success button (Launch, Resume) */
.btn-success {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 600;
  font-family: inherit;
  color: white;
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  border: none;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-success:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
}

.btn-success:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-success svg {
  width: 16px;
  height: 16px;
}

/* Warning button (Pause) */
.btn-warning {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 600;
  font-family: inherit;
  color: white;
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  border: none;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-warning:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(245, 158, 11, 0.3);
}

.btn-warning:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-warning svg {
  width: 16px;
  height: 16px;
}

/* Launch modal icon */
.message-modal-icon.launch {
  background: rgba(16, 185, 129, 0.1);
  color: #059669;
}

/* Success button for modal */
.message-modal-btn-success {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 24px;
  font-size: 14px;
  font-weight: 600;
  font-family: inherit;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  box-shadow: 0 4px 16px rgba(16, 185, 129, 0.3);
}

.message-modal-btn-success:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(16, 185, 129, 0.4);
}

.message-modal-btn-success:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.message-modal-btn-success .btn-spinner {
  width: 16px;
  height: 16px;
  border-width: 2px;
  border-color: rgba(255, 255, 255, 0.3);
  border-top-color: white;
}

/* Responsive */
@media (max-width: 768px) {
  .form-row {
    flex-direction: column;
  }

  .form-group-two-thirds,
  .form-group-third {
    flex: 1 1;
    width: 100%;
  }

  .question-header {
    flex-wrap: wrap;
  }

  .question-type-toggle {
    order: 3;
    width: 100%;
    margin-top: 8px;
  }

  .type-btn {
    flex: 1 1;
    text-align: center;
  }
}

/* ==================================================
   Research price display (header chip + list item)
   ================================================== */

.editor-header-right {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-left: auto;
}

.research-price-chip {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  padding: 7px 14px;
  border-radius: 8px;
  white-space: nowrap;
  background: #ffffff;
  border: 1px solid #e5e7eb;
}

.research-price-chip-label {
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.10em;
  color: #6b7280;
  line-height: 1;
  padding-right: 12px;
  border-right: 1px solid #e5e7eb;
}

.research-price-chip-value {
  display: inline-flex;
  align-items: baseline;
  gap: 6px;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: -0.01em;
  line-height: 1;
  color: #0f172a;
}

.research-price-chip-amount {
  font-variant-numeric: tabular-nums;
}

.research-price-chip-currency {
  font-size: 12px;
  font-weight: 500;
  color: #6b7280;
  letter-spacing: 0.02em;
}

.research-price-chip-muted .research-price-chip-value {
  font-size: 13px;
  font-weight: 500;
  font-style: italic;
  color: #9ca3af;
}

.list-item-price {
  margin-top: 2px;
  font-weight: 600;
  color: #0f172a;
  font-variant-numeric: tabular-nums;
}

.list-item-price-empty {
  font-weight: 500;
  font-style: italic;
  color: #9ca3af;
}

/* Launch confirmation — charge highlight */
.launch-charge-block {
  margin: 16px 0 12px;
  padding: 14px 18px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  background: #fafafa;
  text-align: center;
}

.launch-charge-label {
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.10em;
  color: #6b7280;
  margin-bottom: 6px;
}

.launch-charge-value {
  font-size: 28px;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: #0f172a;
  font-variant-numeric: tabular-nums;
  line-height: 1.1;
}

.launch-warning {
  font-size: 13px;
  color: #6b7280;
  margin-top: 4px;
  line-height: 1.5;
}

.launch-warning strong {
  color: #dc2626;
}

.launch-balance-line {
  margin-top: 8px;
  font-size: 12px;
  color: #6b7280;
}

.launch-warning-error {
  color: #dc2626 !important;
}

/* ---------------------------------------------------------------------------
   Duplicate, on the research row itself — you choose what to clone while
   looking at the whole list, not from inside one open study.
   --------------------------------------------------------------------------- */
.list-item-action {
  width: 30px;
  height: 30px;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid transparent;
  border-radius: 8px;
  background: none;
  color: #9aa0a6;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.15s ease, background 0.15s ease, color 0.15s ease;
}

.list-item-action svg { width: 15px; height: 15px; }

/* Stays out of the way until the row is hovered — but never hidden from a
   keyboard, and always visible on the selected row and on touch. */
.list-item:hover .list-item-action,
.list-item.active .list-item-action,
.list-item-action:focus-visible { opacity: 1; }

@media (hover: none) { .list-item-action { opacity: 1; } }

.list-item-action:hover {
  background: rgba(0, 0, 0, 0.05);
  color: #1a1a1a;
}

.list-item-action:disabled { cursor: default; opacity: 1; }

.list-item-action-spinner {
  width: 13px;
  height: 13px;
  border: 2px solid currentColor;
  border-top-color: transparent;
  border-radius: 50%;
  animation: research-dup-spin 0.7s linear infinite;
}

@keyframes research-dup-spin { to { transform: rotate(360deg); } }
`, "",{"version":3,"sources":["webpack://./src/styles/research.css"],"names":[],"mappings":"AAAA,yBAAyB;;AAEzB,sCAAsC;AACtC;EACE,qBAAqB;EACrB,8BAA8B;EAC9B,wBAAwB;EACxB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,kBAAkB;AAClB;EACE,oCAAoC;EACpC,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;AACf;;AAEA,qBAAqB;AACrB;EACE,SAAO;AACT;;AAEA;EACE,SAAO;AACT;;AAEA,aAAa;AACb;EACE,WAAW;EACX,kBAAkB;EAClB,uCAAuC;EACvC,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,8CAA8C;AAChD;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,qDAAqD;EACrD,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,2DAA2D;AAC3D;EACE,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,4BAA4B;EAC5B,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,0BAA0B;EAC1B,+BAA+B;EAC/B,qCAAqC;EACrC,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,iBAAiB;EACjB,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,0BAA0B;EAC1B,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,2BAA2B;EAC3B,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,4BAA4B;EAC5B,uBAAuB;EACvB,sCAAsC;EACtC,kBAAkB;EAClB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,8BAA8B;AAChC;AACA;EACE,SAAO;EACP,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;AACA,6BAA6B,mBAAmB,EAAE;AAClD;EACE,mBAAmB;EACnB,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,4BAA4B;EAC5B,uBAAuB;EACvB,sCAAsC;EACtC,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA,yCAAyC;AACzC;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA,gCAAgC;AAChC;;EAEE,kCAAkC;AACpC;;AAEA,6BAA6B;AAC7B;EACE,aAAa;AACf;;AAEA,oCAAoC;AACpC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,6DAA6D;EAC7D,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,6DAA6D;EAC7D,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,6DAA6D;EAC7D,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,sCAAsC;EACtC,uBAAuB;AACzB;;AAEA,eAAe;AACf;EACE;IACE,sBAAsB;EACxB;;EAEA;;IAEE,SAAO;IACP,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,SAAO;IACP,kBAAkB;EACpB;AACF;;AAEA;;uDAEuD;;AAEvD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,2CAA2C;AAC3C;EACE,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;gFAGgF;AAChF;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,UAAU;EACV,uEAAuE;AACzE;;AAEA,wBAAwB,WAAW,EAAE,YAAY,EAAE;;AAEnD;mEACmE;AACnE;;kCAEkC,UAAU,EAAE;;AAE9C,uBAAuB,oBAAoB,UAAU,EAAE,EAAE;;AAEzD;EACE,+BAA+B;EAC/B,cAAc;AAChB;;AAEA,6BAA6B,eAAe,EAAE,UAAU,EAAE;;AAE1D;EACE,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,6BAA6B;EAC7B,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA,+BAA+B,KAAK,yBAAyB,EAAE,EAAE","sourcesContent":["/* Research Page Styles */\n\n/* Modal overlay - ensure visibility */\n.modal-overlay:has(.message-modal) {\n  opacity: 1 !important;\n  visibility: visible !important;\n  display: flex !important;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Research form specific styles */\n.research-form {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n/* Form sections */\n.form-section {\n  background: rgba(255, 255, 255, 0.6);\n  border: 1px solid rgba(0, 0, 0, 0.06);\n  border-radius: 16px;\n  padding: 20px;\n}\n\n/* Form row layouts */\n.form-group-two-thirds {\n  flex: 2;\n}\n\n.form-group-third {\n  flex: 1;\n}\n\n/* Textarea */\n.form-textarea {\n  width: 100%;\n  padding: 12px 16px;\n  border: 1.5px solid rgba(0, 0, 0, 0.12);\n  border-radius: 12px;\n  font-size: 15px;\n  font-family: inherit;\n  background: #ffffff;\n  color: var(--text-primary);\n  resize: vertical;\n  min-height: 60px;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);\n  transition: all 0.2s ease;\n}\n\n.form-textarea:hover {\n  border-color: rgba(0, 0, 0, 0.2);\n}\n\n.form-textarea:focus {\n  outline: none;\n  border-color: var(--accent-orange);\n  box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.12);\n}\n\n.form-textarea:disabled {\n  background: rgba(0, 0, 0, 0.04);\n  cursor: not-allowed;\n}\n\n/* Questions section */\n.questions-list {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n/* Question card */\n.question-card {\n  background: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  border-radius: 12px;\n  padding: 16px;\n  transition: all 0.2s ease;\n}\n\n.question-card:hover {\n  border-color: rgba(0, 0, 0, 0.12);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n}\n\n.question-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.question-number {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  background: linear-gradient(135deg, #FF6B4A, #E94B6C);\n  color: white;\n  font-size: 12px;\n  font-weight: 600;\n  border-radius: 50%;\n}\n\n/* Creative break badge — distinct from question numbers. */\n.question-number-creative {\n  background: linear-gradient(135deg, #8E3A9A, #E94B6C);\n}\n\n.question-type-toggle {\n  display: flex;\n  background: rgba(0, 0, 0, 0.04);\n  border-radius: 8px;\n  padding: 2px;\n}\n\n.type-btn {\n  padding: 6px 12px;\n  font-size: 12px;\n  font-weight: 500;\n  font-family: inherit;\n  color: var(--text-secondary);\n  background: transparent;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.type-btn:hover:not(:disabled) {\n  color: var(--text-primary);\n}\n\n.type-btn.active {\n  background: white;\n  color: var(--text-primary);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.type-btn:disabled {\n  cursor: not-allowed;\n}\n\n.remove-question-btn {\n  margin-left: auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  background: transparent;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  color: var(--text-tertiary);\n  transition: all 0.15s ease;\n}\n\n.remove-question-btn:hover {\n  background: rgba(231, 76, 60, 0.1);\n  color: #e74c3c;\n}\n\n.remove-question-btn svg {\n  width: 16px;\n  height: 16px;\n}\n\n.question-input {\n  width: 100%;\n  padding: 12px 14px;\n  font-size: 15px;\n  font-family: inherit;\n  color: var(--text-primary);\n  background: rgba(0, 0, 0, 0.02);\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  border-radius: 10px;\n  transition: all 0.15s ease;\n}\n\n.question-input:hover:not(:disabled) {\n  border-color: rgba(0, 0, 0, 0.12);\n}\n\n.question-input:focus {\n  outline: none;\n  border-color: var(--accent-orange);\n  background: white;\n  box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.1);\n}\n\n.question-input:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n/* Answers */\n.answers-list {\n  margin-top: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.answer-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.answer-marker {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  color: var(--text-tertiary);\n  flex-shrink: 0;\n}\n\n.answer-marker svg {\n  width: 16px;\n  height: 16px;\n}\n\n.answer-input {\n  flex: 1;\n  padding: 10px 12px;\n  font-size: 14px;\n  font-family: inherit;\n  color: var(--text-primary);\n  background: rgba(0, 0, 0, 0.02);\n  border: 1px solid rgba(0, 0, 0, 0.06);\n  border-radius: 8px;\n  transition: all 0.15s ease;\n}\n\n.answer-input:hover:not(:disabled) {\n  border-color: rgba(0, 0, 0, 0.12);\n}\n\n.answer-input:focus {\n  outline: none;\n  border-color: var(--accent-orange);\n  background: white;\n}\n\n.answer-input:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.remove-answer-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  background: transparent;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  color: var(--text-tertiary);\n  transition: all 0.15s ease;\n  flex-shrink: 0;\n}\n\n.remove-answer-btn:hover {\n  background: rgba(231, 76, 60, 0.1);\n  color: #e74c3c;\n}\n\n.remove-answer-btn svg {\n  width: 14px;\n  height: 14px;\n}\n\n.add-answer-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin-left: 30px;\n  padding: 8px 12px;\n  font-size: 13px;\n  font-weight: 500;\n  font-family: inherit;\n  color: var(--text-secondary);\n  background: transparent;\n  border: 1px dashed rgba(0, 0, 0, 0.15);\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.add-answer-btn:hover {\n  color: var(--accent-orange);\n  border-color: var(--accent-orange);\n  background: rgba(255, 107, 74, 0.04);\n}\n\n.add-answer-btn svg {\n  width: 14px;\n  height: 14px;\n}\n\n/* Creative test — image answer options */\n.creative-options {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));\n  gap: 12px;\n  margin-top: 8px;\n}\n.creative-option {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n.creative-thumb {\n  position: relative;\n  aspect-ratio: 1 / 1;\n  border: 1px solid #e5e5ee;\n  border-radius: 10px;\n  overflow: hidden;\n  background: #fafafc;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.creative-thumb img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n.creative-thumb-empty {\n  border-style: dashed;\n  color: #9b9ba8;\n  font-size: 12px;\n}\n.creative-option-actions {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  justify-content: space-between;\n}\n.creative-upload-btn {\n  flex: 1;\n  text-align: center;\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 600;\n  color: #8E3A9A;\n  background: #f6eef8;\n  border-radius: 7px;\n  padding: 6px 8px;\n}\n.creative-upload-btn:hover { background: #efe2f3; }\n.creative-add {\n  aspect-ratio: 1 / 1;\n  flex-direction: column;\n  border: 1px dashed #cfcfe0 !important;\n}\n\n/* Add question button */\n.add-question-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  width: 100%;\n  margin-bottom: 24px;\n  padding: 14px;\n  margin-top: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  font-family: inherit;\n  color: var(--text-secondary);\n  background: transparent;\n  border: 2px dashed rgba(0, 0, 0, 0.12);\n  border-radius: 12px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.add-question-btn:hover {\n  color: var(--accent-orange);\n  border-color: var(--accent-orange);\n  background: rgba(255, 107, 74, 0.04);\n}\n\n.add-question-btn svg {\n  width: 18px;\n  height: 18px;\n}\n\n/* Status badges */\n.status-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 4px 10px;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.03em;\n  border-radius: 12px;\n  white-space: nowrap;\n}\n\n.status-draft {\n  background: rgba(0, 0, 0, 0.06);\n  color: var(--text-secondary);\n}\n\n.status-active {\n  background: rgba(16, 185, 129, 0.1);\n  color: #059669;\n}\n\n.status-completed {\n  background: rgba(59, 130, 246, 0.1);\n  color: #2563eb;\n}\n\n.status-paused {\n  background: rgba(245, 158, 11, 0.1);\n  color: #d97706;\n}\n\n/* Editor header with status */\n.editor-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 20px;\n}\n\n.editor-header h2 {\n  margin: 0;\n}\n\n/* Research list items - compact layout */\n.url-lists-panel .list-item {\n  gap: 10px;\n  padding: 12px 12px;\n}\n\n.url-lists-panel .list-item-icon {\n  width: 32px;\n  height: 32px;\n}\n\n.url-lists-panel .list-item-icon svg {\n  width: 16px;\n  height: 16px;\n}\n\n/* Smaller status badge */\n.url-lists-panel .status-badge {\n  padding: 3px 8px;\n  font-size: 10px;\n  flex-shrink: 0;\n}\n\n/* DM Sans font for list items */\n.url-lists-panel .list-item-name,\n.url-lists-panel .list-item-meta {\n  font-family: 'DM Sans', sans-serif;\n}\n\n/* Hide arrow to save space */\n.url-lists-panel .list-item-arrow {\n  display: none;\n}\n\n/* Success button (Launch, Resume) */\n.btn-success {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 20px;\n  font-size: 14px;\n  font-weight: 600;\n  font-family: inherit;\n  color: white;\n  background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n  border: none;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.btn-success:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);\n}\n\n.btn-success:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.btn-success svg {\n  width: 16px;\n  height: 16px;\n}\n\n/* Warning button (Pause) */\n.btn-warning {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 20px;\n  font-size: 14px;\n  font-weight: 600;\n  font-family: inherit;\n  color: white;\n  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);\n  border: none;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.btn-warning:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(245, 158, 11, 0.3);\n}\n\n.btn-warning:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.btn-warning svg {\n  width: 16px;\n  height: 16px;\n}\n\n/* Launch modal icon */\n.message-modal-icon.launch {\n  background: rgba(16, 185, 129, 0.1);\n  color: #059669;\n}\n\n/* Success button for modal */\n.message-modal-btn-success {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 12px 24px;\n  font-size: 14px;\n  font-weight: 600;\n  font-family: inherit;\n  border: none;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n  color: white;\n  box-shadow: 0 4px 16px rgba(16, 185, 129, 0.3);\n}\n\n.message-modal-btn-success:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: 0 6px 20px rgba(16, 185, 129, 0.4);\n}\n\n.message-modal-btn-success:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.message-modal-btn-success .btn-spinner {\n  width: 16px;\n  height: 16px;\n  border-width: 2px;\n  border-color: rgba(255, 255, 255, 0.3);\n  border-top-color: white;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .form-row {\n    flex-direction: column;\n  }\n\n  .form-group-two-thirds,\n  .form-group-third {\n    flex: 1;\n    width: 100%;\n  }\n\n  .question-header {\n    flex-wrap: wrap;\n  }\n\n  .question-type-toggle {\n    order: 3;\n    width: 100%;\n    margin-top: 8px;\n  }\n\n  .type-btn {\n    flex: 1;\n    text-align: center;\n  }\n}\n\n/* ==================================================\n   Research price display (header chip + list item)\n   ================================================== */\n\n.editor-header-right {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-left: auto;\n}\n\n.research-price-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 12px;\n  padding: 7px 14px;\n  border-radius: 8px;\n  white-space: nowrap;\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n}\n\n.research-price-chip-label {\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.10em;\n  color: #6b7280;\n  line-height: 1;\n  padding-right: 12px;\n  border-right: 1px solid #e5e7eb;\n}\n\n.research-price-chip-value {\n  display: inline-flex;\n  align-items: baseline;\n  gap: 6px;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: -0.01em;\n  line-height: 1;\n  color: #0f172a;\n}\n\n.research-price-chip-amount {\n  font-variant-numeric: tabular-nums;\n}\n\n.research-price-chip-currency {\n  font-size: 12px;\n  font-weight: 500;\n  color: #6b7280;\n  letter-spacing: 0.02em;\n}\n\n.research-price-chip-muted .research-price-chip-value {\n  font-size: 13px;\n  font-weight: 500;\n  font-style: italic;\n  color: #9ca3af;\n}\n\n.list-item-price {\n  margin-top: 2px;\n  font-weight: 600;\n  color: #0f172a;\n  font-variant-numeric: tabular-nums;\n}\n\n.list-item-price-empty {\n  font-weight: 500;\n  font-style: italic;\n  color: #9ca3af;\n}\n\n/* Launch confirmation — charge highlight */\n.launch-charge-block {\n  margin: 16px 0 12px;\n  padding: 14px 18px;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  background: #fafafa;\n  text-align: center;\n}\n\n.launch-charge-label {\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.10em;\n  color: #6b7280;\n  margin-bottom: 6px;\n}\n\n.launch-charge-value {\n  font-size: 28px;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  color: #0f172a;\n  font-variant-numeric: tabular-nums;\n  line-height: 1.1;\n}\n\n.launch-warning {\n  font-size: 13px;\n  color: #6b7280;\n  margin-top: 4px;\n  line-height: 1.5;\n}\n\n.launch-warning strong {\n  color: #dc2626;\n}\n\n.launch-balance-line {\n  margin-top: 8px;\n  font-size: 12px;\n  color: #6b7280;\n}\n\n.launch-warning-error {\n  color: #dc2626 !important;\n}\n\n/* ---------------------------------------------------------------------------\n   Duplicate, on the research row itself — you choose what to clone while\n   looking at the whole list, not from inside one open study.\n   --------------------------------------------------------------------------- */\n.list-item-action {\n  width: 30px;\n  height: 30px;\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid transparent;\n  border-radius: 8px;\n  background: none;\n  color: #9aa0a6;\n  cursor: pointer;\n  opacity: 0;\n  transition: opacity 0.15s ease, background 0.15s ease, color 0.15s ease;\n}\n\n.list-item-action svg { width: 15px; height: 15px; }\n\n/* Stays out of the way until the row is hovered — but never hidden from a\n   keyboard, and always visible on the selected row and on touch. */\n.list-item:hover .list-item-action,\n.list-item.active .list-item-action,\n.list-item-action:focus-visible { opacity: 1; }\n\n@media (hover: none) { .list-item-action { opacity: 1; } }\n\n.list-item-action:hover {\n  background: rgba(0, 0, 0, 0.05);\n  color: #1a1a1a;\n}\n\n.list-item-action:disabled { cursor: default; opacity: 1; }\n\n.list-item-action-spinner {\n  width: 13px;\n  height: 13px;\n  border: 2px solid currentColor;\n  border-top-color: transparent;\n  border-radius: 50%;\n  animation: research-dup-spin 0.7s linear infinite;\n}\n\n@keyframes research-dup-spin { to { transform: rotate(360deg); } }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
